import ApiService from "@/common/api/api.service";
import Aneel from "./accordion/Aneel";
import RH from "./accordion/RH";
import Generico from "./accordion/Generico";
import CronogramaEtapa from "./accordion/CronogramaEtapa";
import Entregavel from "./accordion/Entregavel";
import CronogramaFinanceiro from "./accordion/CronogramaFinanceiro";
import Investimentos from "./accordion/Investimentos";
import ContratoDocumentacao from "./accordion/ContratoDocumentacao";
import ComprovanteHH from "./accordion/ComprovanteHH";


let endpoint = "Projeto";


const ProjetoService = {

    setEndpoint: function (endpointSelecionado) {
        endpoint = endpointSelecionado;
        let accordion = [RH, Generico, CronogramaEtapa, Entregavel, CronogramaFinanceiro, Investimentos];
        accordion.forEach(function (item) {
            item.setEndpoint(endpoint);
        });
    },

    getEndpoint: function () {
        return endpoint;
    },

    novoProjeto: function (form) {
        return ApiService.post(`Projeto`, form);
    },

    buscarPropostas: function (empresaId) {
        return ApiService.get(`Projeto/propostas?EmpresaId=${empresaId}`);
    },

    buscarProjeto: function (id) {
        return ApiService.get(`${endpoint}/${id}`);
    },

    listar: function (empresaId, texto = "", tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`${endpoint}?EmpresaId=${empresaId}&texto=${texto}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    listarAgrupados: function (empresaId, texto = "", tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`Projeto/agrupados?EmpresaId=${empresaId}&Titulo=${texto}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    listarEmpresasInvestidoras: function (projetoId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`Projeto/empresas-pagadoras?ProjetoId=${projetoId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    listarEmpresasAssociadas: function (projetoId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`Projeto/empresas-associadas?ProjetoId=${projetoId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    listarEmpresas: function (projetoId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`Projeto/todas-empresas?ProjetoId=${projetoId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    listarPessoas: function (projetoId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`Projeto/pessoas-associadas?ProjetoId=${projetoId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    buscarRubricas: function (projetoId, nomeIdProjeto) {
        return new Promise((resolve, reject) => {
            Promise.all([
                this.listarGenerico('servico-terceiro', projetoId, nomeIdProjeto),
                this.listarGenerico('recurso-humano', projetoId, nomeIdProjeto),
                this.listarGenerico('material-consumo', projetoId, nomeIdProjeto),
                this.listarGenerico('material-permanente', projetoId, nomeIdProjeto),
                this.listarGenerico('viagem-diaria', projetoId, nomeIdProjeto),
                this.listarGenerico('outro-recurso', projetoId, nomeIdProjeto)
            ]).then(responses => {
                resolve({
                     servicosTerceiros: responses[0].data.data.itens,
                     recursoHumano: responses[1].data.data,
                    materiaisConsumo: responses[2].data.data.itens,
                    materiaisPermanentesEquipamentos: responses[3].data.data.itens,
                    viagensDiarias: responses[4].data.data.itens,
                    outrosRecursos: responses[5].data.data.itens,
                });
            }).catch(error => {
                reject(error);
            });
        });
    },

    //XMLs
    salvarXML: Aneel.salvar,
    listarXML: Aneel.listar,
    buscarXML: Aneel.buscar,
    deletarXML: Aneel.deletar,
    downloadXML: Aneel.download,

    //RH
    adicionarRH: RH.adicionar,
    listarRH: RH.listar,
    salvarRH: RH.salvar,
    deletarRH: RH.deletar,
    retornaAlocacao: RH.retornaAlocacao,
    salvarAlocacao: RH.salvarAlocacao,

    //Generico
    salvarGenerico: Generico.salvar,
    atualizarGenerico: Generico.atualizar,
    listarGenerico: Generico.listar,
    buscarGenerico: Generico.buscar,
    deletarGenerico: Generico.deletar,
    deletarGenericoObj: Generico.deletarObj,
    downloadArquivoGenerico: Generico.downloadArquivo,
    downloadArquivoCustoGenerico: Generico.downloadArquivoCusto,

    //empresas 
    salvarEmpresas(tipo, form) {
        return ApiService.post(`${tipo != 'executoras' ? 'Projeto' : 'ProjetoEmpresaExecutoraCriadora'}/empresas-${tipo}`, form)
    },
    removerEmpresa(tipo, form) {
        return ApiService.delete(`${tipo != 'executoras' ? 'Projeto' : 'ProjetoEmpresaExecutoraCriadora'}/empresas-${tipo}`, form);
    },

    //CronogramaEtapa
    salvarEtapa: CronogramaEtapa.salvarEtapa,
    salvarSubetapa: CronogramaEtapa.salvarSubetapa,
    salvarRelatorio: CronogramaEtapa.salvarRelatorio,
    removerRelatorio: CronogramaEtapa.removerRelatorio,
    removerSubetapa: CronogramaEtapa.removerSubetapa,
    salvarDetalhamento: CronogramaEtapa.salvarDetalhamento,
    excluirCronograma: CronogramaEtapa.excluirCronograma,
    listarCronograma: CronogramaEtapa.listarCronograma,
    uploadRelatorio: CronogramaEtapa.uploadRelatorio,
    downloadRelatorio: CronogramaEtapa.downloadRelatorio,
    aprovarRelatorio: CronogramaEtapa.aprovarRelatorio,
    excluirArquivo: CronogramaEtapa.excluirArquivo,
    buscarCronogramaPeloRelatorio: CronogramaEtapa.buscarCronogramaPeloRelatorio,

    salvarEntregavel: Entregavel.salvarEntregavel,
    aprovarEntregavel: Entregavel.aprovarEntregavel,
    listarEntregaveis: Entregavel.listarEntregaveis,
    uploadEntregavel: Entregavel.uploadEntregavel,
    downloadEntregavel: Entregavel.downloadEntregavel,
    removerEntregavel: Entregavel.removerEntregavel,
    removerArquivoVersionado: Entregavel.removerArquivoVersionado,

    salvarDesembolsoNaoPrevisto: CronogramaFinanceiro.salvarDesembolsoNaoPrevisto,
    salvarDesembolso: CronogramaFinanceiro.salvarDesembolso,
    deletarDesembolso: CronogramaFinanceiro.deletarDesembolso,
    aprovarDesembolso: CronogramaFinanceiro.aprovarDesembolso,
    reprovarDesembolso: CronogramaFinanceiro.reprovarDesembolso,

    buscarInvestimentos: Investimentos.buscarInvestimentos,
    buscarInvestimentosExecutora: Investimentos.buscarInvestimentosExecutora,
    salvarInvestimento: Investimentos.salvarInvestimento,

    salvarContratoDocumentacao: ContratoDocumentacao.salvarContratoDocumentacao,
    listarContratoDocumentacao: ContratoDocumentacao.listarContratoDocumentacao,
    excluirContratoDocumentacao: ContratoDocumentacao.excluirContratoDocumentacao,
    baixarContratoDocumentacao: ContratoDocumentacao.baixarContratoDocumentacao,

    listarCaracteristicas(rubrica, projetoId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`ProjetoEmpresaExecutoraCriadora/${rubrica}?ProjetoId=${projetoId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    atualizarCaracteristicas(rubrica, form) {
        return ApiService.put(`ProjetoEmpresaExecutoraCriadora/${rubrica}`, form);
    },

    buscarRubricaProposta(tipoProposta, rubrica, propostaId) {
        return ApiService.get(`${tipoProposta}/${rubrica}?PropostaId=${propostaId}`);
    },

    buscarEmpresas(projetoId) {
        return ApiService.get(`Projeto/Empresas?ProjetoId=${projetoId}`);
    },

    criarPorXML(form) {
        return ApiService.post('Projeto/criar-por-xml', form);
    },

    relatorioConsolidadoPDF(id, consolidado) {
        return ApiService.downloadFile(`${endpoint}/relatorio-consolidado-pdf?id=${id}&consolidado=${consolidado}`);
    },

    baixarComprovanteRubricas(id, rubrica) {
        return ApiService.downloadFile(`${endpoint}/comprovantes-${rubrica}?projetoId=${id}`);
    },

    baixarComprovantes(id, incluirPagadora) {
        return ApiService.downloadFile(`${endpoint}/comprovantes?id=${id}&projetoId=${id}&IncluirComprovantesEmQueSouPagadora=${incluirPagadora}`);
    },

    baixarAnexo5(id, consolidado = false) {
        return ApiService.get(`${endpoint}/anexo5?id=${id}&Consolidado=${consolidado}`);
    },

    baixarHH(id, idRH, data) {
        return ApiService.downloadFile(`${endpoint}/declaracao-hh?id=${id}&pessoaId=${idRH}${data ? `&data=${data}` : ''}`);
    },

    apagar(id) {
        return ApiService.delete(`Projeto?id=${id}`);
    },

    temMovimentacao(id) {
        return ApiService.get(`Projeto/tem-movimentacao/${id}`);
    },


    //ComprovanteHH
    salvarComprovanteHH: ComprovanteHH.salvar,
    listarComprovanteHH: ComprovanteHH.listar,
    buscarComprovanteHH: ComprovanteHH.buscar,
    deletarComprovanteHH: ComprovanteHH.deletar,
    downloadComprovanteHH: ComprovanteHH.downloadComprovanteHH,

};


export default ProjetoService;
